import { Search, Loader2, ArrowRight, Globe, AlertTriangle } from "lucide-react";
import { useAnalyzer } from "@/context/AnalyzerContext";

export default function AnalyzerInput() {
  const { url, setUrl, analyze, phase, error } = useAnalyzer();

  const submit = (e) => { e.preventDefault(); analyze(); };

  return (
    <div className="w-full max-w-xl">
      <form onSubmit={submit} className="flex flex-col sm:flex-row sm:items-stretch bg-white border border-slate-200 rounded-xl card-shadow focus-within:border-brand transition-colors p-1.5 sm:p-0">
        <div className="flex items-center flex-1 min-w-0">
          <div className="flex items-center pl-3 text-slate-400 shrink-0">
            <Globe size={18} />
          </div>
          <input
            data-testid="analyzer-url-input"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter your website URL"
            className="flex-1 min-w-0 w-full px-3 py-3.5 text-base outline-none bg-transparent placeholder:text-slate-400"
          />
        </div>
        <button
          type="submit"
          data-testid="analyzer-submit"
          disabled={phase === "loading"}
          className="btn-primary px-6 py-3.5 sm:m-1.5 rounded-lg flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-70 shrink-0"
        >
          {phase === "loading" ? <Loader2 className="animate-spin" size={18} /> : <>Analyze My Website <ArrowRight size={16} /></>}
        </button>
      </form>

      {error && (
        <div className="mt-2 flex items-center gap-2 text-red-500 text-sm" data-testid="analyzer-error">
          <AlertTriangle size={14} /> {error}
        </div>
      )}
    </div>
  );
}
